<template>
  <div ref="lastArticlesHeader" class="lastArticlesContainer">
    <v-toolbar class="categoriesHeader" elevation="0"
    >
      <v-icon @click="goBack">
        mdi-chevron-left
      </v-icon>


      <v-toolbar-title class="pageTitle">
        Bestellungen ansehen
      </v-toolbar-title>
    </v-toolbar>
    <v-divider class="headerDivider"/>
    <div class="contentWrapper ordersContent" ref="contentWrapper">
    <v-card elevation="0" class="filterCard">
      <v-container>
        <v-row>
          <v-col cols="4" class="orderSelectorDesc">
            <span>Zeitfilter:</span>
          </v-col>
          <v-col cols="8">
            <v-select :items="timestamps"
                      v-model="timestampsSelect"
                      item-text="name"
                      item-value="val"
                      return-object
                      class="textSize__14 orderTimestampSelector"
                      filled
                      dense
            >

            </v-select>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-btn class="applyOrderFilterBtn"
                   @click="getOrders(timestampsSelect.val)"
            >
              <span>
                Anwenden
              </span>
            </v-btn>
          </v-col>
        </v-row>
      </v-container>
    </v-card>

    <div class="lastArticlesWrapper mt-3">
    <v-row v-if="!isLoading" class="articleCardRow">
      <v-col cols="12" class="articleCardCol"
             v-for="order in this.fetchedOrders"
             :key="order.orderId"
             @click="showOrder(order)"
      >
        <v-card
            class="articleCard"
            elevation="0"
        >
          <v-list-item>
            <v-container>
              <v-row class="orderCard">
                <v-col cols="12">
                  <b>Bestellnummer: </b>
                  <span>{{ order.orderId }}</span>
                </v-col>

                <v-col cols="12">
                  <b>Bestelldatum: </b>
                  <span>{{ order.orderedAt }}</span>
                </v-col>

                <v-col cols="12">
                  <b>Artikelanzahl: </b>
                  <span>{{ order.cartContent.length }}</span>
                </v-col>

              <!--
                <v-col cols="12" v-if="order.cartContent.length >1">
                  <span>Beinhaltet u. a.: </span>
                  <span v-for="(article,index) in order.cartContent"
                        :key="index">
                    {{ article.description }},
                  </span>
                </v-col>
                <v-col cols="12" v-if="order.cartContent.length === 1">
                  <span>Beinhaltet: </span>
                  <span>
                    {{ order.cartContent[0].description }}
                  </span>
                </v-col>
                -->
              </v-row>
            </v-container>
          </v-list-item>
        </v-card>
      </v-col>
    </v-row>
    </div>
      <div class="bottomFiller"/>
    </div>
  </div>
</template>

<script>
import {mapActions, mapMutations} from 'vuex'
import router from '@/router'
export default {
  name: "orders",

  data:() => {
    return {
      timestampsSelect: 'd30',
      orderTypesSelect: 1,
      timestamps: [
                    {name: 'Letzte 30 Tage', val: 'd30'},
                    {name: 'Letzte 60 Tage', val: 'd60'},
                    {name: 'Letzte 90 Tage', val: 'd90'},
                    {name: 'Letzte 3 Monate', val:'m3'},
                    {name: 'Letzte 6 Monate', val:'m6'},
                    {name:'2023', val:'y2023'},
                    {name:'2022', val:'y2022'},
                    {name:'2021', val:'y2021'},
                    {name:'2020', val:'y2020'},
                    {name:'2019', val:'y2019'}
                    ],
      orderTypes: [
                    {name:'Bestellungen', val: 1},
                  ],

      isLoading: true,
      fetchedOrders: null
    }
  },

  methods: {
    ...mapActions({
      setHeaderVisibility: 'setHeaderVisibility',
      fetchOrders: 'fetchOrders'
    }),

    ...mapMutations({
      setOrder: 'setOrder'
    }),

    getOrders(param) {
      this.isLoading = true
      this.fetchOrders(param).then((response) => {
        this.fetchedOrders = response.data
        this.isLoading = false
      })
    },

    showOrder(order) {
      this.setOrder(order)
      router.push({name: 'Bestelldetails', params:{id: order.orderId}})
    },

    goBack() {
      router.go(-1)
    },
  },

  computed: {
  },

  created() {
    this.setHeaderVisibility(false)
    this.fetchOrders('d30').then((response) => {
      this.fetchedOrders = response.data
      this.isLoading = false
    })
  }
}
</script>

<style>
 .center {
   margin: auto;
 }

 .ordersContent {
   padding-top: 15px;
 }

 .ordersContent .filterCard {
   padding: 15px;
 }

 .orderTimestampSelector.v-text-field.v-text-field--enclosed:not(.v-text-field--rounded) > .v-input__control > .v-input__slot, .v-text-field.v-text-field--enclosed .v-text-field__details {
    padding-left: 20px!important;
 }

 .orderCard {
   display: flex;
   flex-direction: column;
 }

 .orderCard .col {
   text-align: left;
 }

 .orderSelectorDesc {
   text-align: left;
 }
</style>
